import { render, staticRenderFns } from "./medicalRecordsDetails.vue?vue&type=template&id=a38cf886&scoped=true"
import script from "./medicalRecordsDetails.vue?vue&type=script&lang=js"
export * from "./medicalRecordsDetails.vue?vue&type=script&lang=js"
import style0 from "./medicalRecordsDetails.vue?vue&type=style&index=0&id=a38cf886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38cf886",
  null
  
)

export default component.exports